import React from 'react';
import { Link } from 'react-router-dom';

const ICADLA = () => {
  return (
    <div className="page icadla-page">
      <div className="container">
        {/* Promotional Header */}
        <section className="promo-hero">
          <div className="promo-content">
            <h1>🎄 Christmas & New Year Special 🎉</h1>
            <p className="promo-subtitle">Get 20% Off All Bookkeeping Services</p>
            <p className="promo-description">
              Limited time offer for the holiday season! Register now and get matched with 
              professional bookkeepers or find new clients for your services.
            </p>
            <div className="promo-badges">
              <span className="badge">🎁 20% Discount</span>
              <span className="badge">⏰ Limited Time</span>
              <span className="badge">⭐ Premium Matching</span>
            </div>
          </div>
        </section>

        {/* Registration Options */}
        <section className="registration-options">
          <h2>Choose Your Registration</h2>
          <div className="options-grid">
            {/* Bookkeeper Registration */}
            <div className="option-card bookkeeper-option">
              <div className="option-icon">📊</div>
              <h3>Register as Bookkeeper</h3>
              <p>Join our network and get connected with clients looking for bookkeeping services during the holiday season.</p>
              <ul className="benefits-list">
                <li>✓ Get matched with local clients</li>
                <li>✓ Special holiday promotion</li>
                <li>✓ Increased visibility</li>
                <li>✓ Priority listing</li>
              </ul>
              <Link to="/icadla/bookkeeper" className="option-btn bookkeeper-btn">
                Register as Bookkeeper
              </Link>
            </div>

            {/* Service Requester Registration */}
            <div className="option-card requester-option">
              <div className="option-icon">👥</div>
              <h3>Need Bookkeeping Services?</h3>
              <p>Find qualified bookkeepers in your area and get 20% off services during our holiday promotion.</p>
              <ul className="benefits-list">
                <li>✓ 20% holiday discount</li>
                <li>✓ Pre-vetted professionals</li>
                <li>✓ Local bookkeepers</li>
                <li>✓ Quick matching</li>
              </ul>
              <Link to="/icadla/requester" className="option-btn requester-btn">
                Find Bookkeepers
              </Link>
            </div>
          </div>
        </section>

        {/* Additional Promotional Info */}
        <section className="promo-info">
          <h2>Holiday Special Details</h2>
          <div className="info-grid">
            <div className="info-item">
              <h4>🎁 Special Offer</h4>
              <p>20% discount on all bookkeeping services for new clients registered through this promotion.</p>
            </div>
            <div className="info-item">
              <h4>⏰ Limited Time</h4>
              <p>This promotion is valid from December 15th to January 15th. Don't miss out!</p>
            </div>
            <div className="info-item">
              <h4>⭐ Premium Service</h4>
              <p>All bookkeepers are vetted professionals with experience in various industries.</p>
            </div>
            <div className="info-item">
              <h4>🔒 Secure Matching</h4>
              <p>Your information is secure and we'll match you with the perfect bookkeeping solution.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ICADLA;